import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 -mt-2 text-xs font-bold text-left text-red-600"
}
const _hoisted_2 = { class: "grid grid-cols-2 gap-5 text-left" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = ["innerHTML"]

import { ref, onMounted, watch } from 'vue';

import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import PageLoader from "@/components/PageLoader.vue";

import BookingService from '@/classes/BookingService';
import { daysOfTheWeek } from '@/helpers/PackageRiderHelper';

interface IndividualReschedulePayloadInterface {
    booking_id : number,
    branch_id : number,
    booking_date: string,
    booking_start_time: string,
    booking_end_time : string,
    remarks: string,
    updated_by: string 
}

interface CorporateReschedulePayloadInterface {
    corporate_booking_id : number,
    new_booking_date: string,
    new_booking_time: string,
    new_booking_end_time : string,
    remarks: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RescheduleModal',
  props: {
    show: {
        type: Boolean,
        defualt: false,
    },
    bookingId: {
        type: Number,
        required: true
    },
    branchId: {
        type: Number,
        required: true
    },
    bookingType: {
        type: String,
        required: true
    },
    bookingDate: {
        type: String,
        required: true
    },
    package: {
        type: String,
        required: true
    },
    riders: {
        type: Object,
        default: () => ({})
    },
},
  emits: ['close', 'success'],
  setup(__props, { emit: __emit }) {

const emit = __emit;


const props = __props;


const show = ref<boolean>(props.show)
const loader = ref<boolean>(true)
const showError = ref<boolean>(false)
const errorMsg = ref<string>('')
const errors = ref<any[]>([])

const from = ref<string>('')
const to = ref<string>('')
const selectedSlot = ref<string|null>(null)
const timeSlots = ref<any[]>(daysOfTheWeek.map((date) => date.value))
const disabledDates = ref<any[]>([])

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();

const payload = ref<IndividualReschedulePayloadInterface>({
    booking_id : props.bookingId,
    branch_id : props.branchId,
    booking_date: '',
    booking_start_time: '',
    booking_end_time : '',
    remarks: '',
    updated_by: 'admin' 
})

const getGetAvailableDates = () => {
    loader.value = true

    BookingService.getGetAvailableDates({
        package: props.package,
        riders: props.riders
    })
    .then(({data}: any) => {
        loader.value = false
        console.log(data);

        disabledDates.value = data.response
    })
    .catch((err) => {
        loader.value = false;
        showError.value = true;
        errorMsg.value = err.response.data.message;
        
        if(err.response.status == 401) {
            window.location.replace('/login')
        }
    })
}
const fetchDateAndTime = () => {
    if(payload.value.booking_date && payload.value.booking_date !== ''){
        loader.value = true
    
        const data = {
            branch_id: props.branchId,
            selected_date: payload.value.booking_date,
            from: from.value,
            to: to.value,
            package: props.package,
            riders: props.riders,
        }
    
        BookingService.fetchDateAndTime(data)
            .then((result: any) => {
                loader.value = false;
    
                timeSlots.value = result.data.response
            })
            .catch((error) => {
                loader.value = false;
                showError.value = true;
                // errorMsg.value = error;
                errorMsg.value = error.response?.data?.message;
    
                if(error.response.status == 401) {
                    window.location.replace('/login')
                }
            })
    }
}

const rescheduleBooking = () => {
    caches.delete('shinagawa-admin');
    
    loader.value = true;

    BookingService.rescheduleBooking(props.bookingType, buildPayload())
        .then(({data}) => {
            if(data.response.result_status == 200 && data.response.message == 'Success') {
                success()
            } else if(data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const buildPayload = (): IndividualReschedulePayloadInterface|CorporateReschedulePayloadInterface => {
    
    payload.value.booking_date = new Date(payload.value.booking_date).toISOString().split('T')[0];

    if( props.bookingType.toLowerCase() == 'individual' || props.bookingType.toLowerCase() == 'dependent' ){
        return payload.value
    } else {
        return {
            corporate_booking_id: payload.value.booking_id,
            new_booking_date: payload.value.booking_date,
            new_booking_time: payload.value.booking_start_time,
            new_booking_end_time: payload.value.booking_end_time,
            remarks: payload.value.remarks,
        }
    }
}

const updateMonth = (val:any = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
    fetchDateAndTime();
}

const firstDayOfMonth = (val:any) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val:any) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}


const setStartEndTime = (value:string) => {
    if(value){
        const [start, end] = value.split('-');
    
        payload.value.booking_start_time = stringToTime(start);
        payload.value.booking_end_time = stringToTime(end);
    }
}

// This function takes a string in the format of "h:mm AM/PM" and returns a string in the format of "hh:mm:ss"
const stringToTime = (str:string): string => {
    // Split the string by space and colon
    const time:string[] = str.split(/[: ]/);
    // Convert hour and minute to numbers
    let hour:number = parseInt(time[0]);
    const minute:number = parseInt(time[1]);
    const period:string = time[2];
    // Check if the period is valid
    if (period !== "AM" && period !== "PM") {
        return "Invalid period";
    }
    // Check if the hour and minute are valid
    if (hour < 1 || hour > 12 || minute < 0 || minute > 59) {
        return "Invalid time";
    }
    // Convert hour to 24-hour format
    if (period === "PM" && hour < 12) {
        hour += 12;
    }
    if (period === "AM" && hour === 12) {
        hour = 0;
    }
    // Pad hour and minute with zeros if needed
    const newHour:string = hour.toString().padStart(2, "0");
    const newMinute:string = minute.toString().padStart(2, "0");
    // Return the time in the format of "hh:mm:ss"
    return `${newHour}:${newMinute}:00`;
}

const close = () => {
    show.value = false
    emit('close')
}

const success = () => {
    loader.value = false;
    show.value = false
    emit('success')
}


watch(
    () => payload.value.booking_date,
    (val) => {
        if(val){      
            const selectedDate = new Date(val);
    
            updateMonth({
                year: selectedDate.getFullYear(),
                month: selectedDate.getMonth()
            })
        } else {
            selectedSlot.value = null;
            timeSlots.value = daysOfTheWeek.map((date) => date.value)
        }
    },
    { immediate: true }
);


onMounted(() => {
    getGetAvailableDates()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      show: show.value,
      onCancel: close,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (rescheduleBooking())),
      "cancel-text": "Cancel",
      "action-text": "Submit",
      title: "Reschedule Appointment?",
      content: "Are you sure you wish to reschedule this appointment?",
      "disabled-button": loader.value
    }, {
      fields: _withCtx(() => [
        (__props.bookingType != 'Individual')
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" WARNING: Canceling/Rescheduling a Company Booking will affect ", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" all bookings associated with it. ", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextInput, {
              modelValue: payload.value.remarks,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.remarks) = $event)),
              label: "Reason",
              placeholder: "Reason"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DatePicker, {
              modelValue: payload.value.booking_date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.booking_date) = $event)),
              label: "Booking Date",
              placeholder: "MM/DD/YYYY",
              "min-date": new Date(),
              "hide-offset-dates": "",
              "highlight-disabled-days": "",
              onUpdateMonth: updateMonth,
              "teleport-center": "",
              disabledWeekDays: Object.values(disabledDates.value)
            }, null, 8, ["modelValue", "min-date", "disabledWeekDays"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(MultiselectInput, {
              disabled: !payload.value.booking_date,
              modelValue: selectedSlot.value,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((selectedSlot).value = $event)),
                setStartEndTime
              ],
              id: "selectedSlot",
              name: "selectedSlot",
              label: "Time Slots",
              placeholder: "Time Slots",
              searchable: "",
              options: timeSlots.value
            }, null, 8, ["disabled", "modelValue", "options"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "disabled-button"]),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (close())),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("p", { innerHTML: errorMsg.value }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})